import { Controller } from "stimulus";

export default class extends Controller {
  close() {
    event.preventDefault();
    $(".sidebar").addClass("d-none");
  }
}
